document.addEventListener('DOMContentLoaded', function() {
    
    // ✅ Inicializa Thumbs PRIMEIRO
    var thumbsSwiper = new Swiper(".mySwiper", {
        spaceBetween: 12,
        slidesPerView: 4,
        breakpoints: {
            992: {
                slidesPerView: 5,
                allowTouchMove: false,
            }
        },
        freeMode: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
    });

    // ✅ Inicializa Principal
    var mainSwiper = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        breakpoints: {
            992: {
                allowTouchMove: false,
            }
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        on: {
            init: function() {
                thumbsSwiper.update();
            }
        }
    });

    const btnPrev = document.querySelector('.arrowa > .prev');
    const btnNext = document.querySelector('.arrowa > .next');

    if (btnPrev) {
        btnPrev.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            mainSwiper.slidePrev();
        });
    }

    if (btnNext) {
        btnNext.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            mainSwiper.slideNext();
        });
    }
});

/**Linha do tempo - Acordeão */
// 1. BANCO DE DADOS: Armazena todo o conteúdo aqui
const dadosLinhaTempo = window.dadosLinhaTempo || [];

// Elementos do DOM
const elListaAnos = document.getElementById('lista-anos');
const btnPrev = document.getElementById('btn-prev');
const btnNext = document.getElementById('btn-next');

if (elListaAnos && dadosLinhaTempo.length) {

    // 2. RENDERIZAÇÃO: cada ano é um item de acordeão, com o conteúdo já dentro dele
    elListaAnos.innerHTML = dadosLinhaTempo.map((item, index) => `
        <div class="ano-item${index === 0 ? ' active' : ''}" data-index="${index}">
            <div class="ano-header">${item.ano}</div>
            <div class="ano-body">
                <div class="ano-content">
                    <h5>${item.titulo}</h5>
                    <p>${item.descricao}</p>
                </div>
            </div>
        </div>
    `).join('');

    const elItens = () => Array.from(elListaAnos.querySelectorAll('.ano-item'));

    // 3. INTERAÇÃO: clicar no ano abre/fecha o conteúdo dele, no próprio lugar (acordeão)
    function abrirItem(item) {
        if (!item) return;

        const jaEstavaAberto = item.classList.contains('active');

        elItens().forEach(el => el.classList.remove('active'));

        if (!jaEstavaAberto) {
            item.classList.add('active');
        }
    }

    elListaAnos.addEventListener('click', (e) => {
        const header = e.target.closest('.ano-header');
        if (!header) return;

        abrirItem(header.closest('.ano-item'));
    });

    // 4. Navegação por setas: abre o ano anterior/próximo em relação ao que está aberto
    function navegar(direcao) {
        const itens = elItens();
        const indexAtual = itens.findIndex(el => el.classList.contains('active'));

        let proximoIndex;
        if (direcao === 'next') {
            proximoIndex = indexAtual < itens.length - 1 ? indexAtual + 1 : 0;
        } else {
            proximoIndex = indexAtual > 0 ? indexAtual - 1 : itens.length - 1;
        }

        itens.forEach(el => el.classList.remove('active'));
        itens[proximoIndex].classList.add('active');
        itens[proximoIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    if (btnPrev) btnPrev.addEventListener('click', () => navegar('prev'));
    if (btnNext) btnNext.addEventListener('click', () => navegar('next'));
}